<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import PageGrid from '../components/pageGrid.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			cards: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content}>
	<PageGrid gridClass="gap-y-8 lg:gap-4">
		{#each content.cards as card}
			<Blok content={card} />
		{/each}
	</PageGrid>
</section>
